import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { StationService } from '@accounts/user/services/station.service';
import { TariffService } from '@accounts/user/services/tariff.service';
import { GasNetworkTariffModel } from '@core/api';

@Component({
  selector: 'user-modal-tariff-list',
  templateUrl: './modal-tariff-list.component.html',
  styleUrls: ['./modal-tariff-list.component.scss']
})
export class ModalTariffListComponent implements OnInit {

  constructor(
    public stationService: StationService,
    public tariffService: TariffService,
  ) { }

  getActive (tariff) {
    return (this.tariffService.tariff && (tariff.min_rent_hours === this.tariffService.tariff.min_rent_hours));
  }

  select(tariff: GasNetworkTariffModel) {
    // this.tariffService.changeCurrentTariff(tariff.min_rent_hours);
  }

  closeCurrentTrailer() {
    this.stationService.reset();
    this.tariffService.reset();
  }

  ngOnInit() {
  }

}
